import api from './client';

export const getAcademyGuides = () => api.get('/academy').then((response) => response.data);
export const getAcademyGuide = (guide) => api.get(`/academy/${guide}`).then((response) => response.data);
